import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import { Show, useShowController } from "react-admin";
import ProfessorsCommission from "./ProfessorsCommission";
import StateExamGeneralInfo from "./StateExamGeneralInfo";
import StateExamSlots from "./StateExamSlots";

const ShowInternshipStateExams = () => {
  const { record } = useShowController();

  return (
    <Show
      title="Детайли на държавен изпит"
      actions={<BackButtonToolbar />}
    >
      <StateExamGeneralInfo record={record} />
      <ProfessorsCommission record={record} />
      <StateExamSlots record={record} />
    </Show>
  );
};

export default ShowInternshipStateExams;
